import React from 'react';
import LoginElement from "../user/LoginElement";
import useUser from "../auth/useUser";
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import {Button} from "@mui/material";

export interface ICheckoutLoginProps {
}

const CheckoutLogin = (props: ICheckoutLoginProps) => {
  const [user, userActions] = useUser();
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl max-lg:max-w-4xl mx-auto p-6">
      <div className="grid items-start grid-cols-1 md:grid-cols-2 gap-20"
           hidden={user.isAuthenticated}>
        <Box>
          <LoginElement
            type="login"
            onLogin={() => {
              navigate("/cart-checkout");
            }}
            header={{
              labelLogin: "Ich bin bereits Kunde",
              className: "text-2xl mb-6"
            }}
            button={{
              fullWidth: false
            }}
          ></LoginElement>
        </Box>
        <Box>
          <Box className="text-2xl mb-6">Als Gast zur Kasse</Box>
          <Box className="">Weiter zur Kasse. Nach der Bestellung kann optional ein Kundenkonto angelegt werden.</Box>
          <Button component={Link}
                  to={"/cart-checkout"}
                  variant="outlined"
                  sx={{marginTop: 4}}>
            Als Gast bestellen
          </Button>
        </Box>
      </div>
    </div>
  );

};

export default CheckoutLogin;
